var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Avatar as WafflesAvatar } from '../avatar';
import { useCard } from './card-context';
function Avatar(_a) {
    var { content } = _a, restProps = __rest(_a, ["content"]);
    const { size } = useCard();
    return (_jsx(WafflesAvatar, Object.assign({ content: content, size: size === 'large' ? 'medium' : 'small', variant: "base" }, restProps)));
}
export default Avatar;
